import { Menu } from "@mui/icons-material"; // GLOBAL CUSTOM COMPONENTS
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery"; // MUI ICON COMPONENTS
import Link from "next/link";
import { H2 } from "src/lib/components/salify-next-layout/default/components/Typography";
import FlexBox from "src/lib/components/salify-next-layout/default/components/flex-box/flex-box";
import { Navigation } from "src/lib/components/salify-next-layout/default/components/layouts/customer-dashboard"; // STYLED COMPONENT
import { SideNav } from "src/lib/components/salify-next-layout/default/components/side-nav";

const StyledBox = styled("div")(({ theme }) => ({
  display: "flex",
  marginTop: theme.spacing(-2),
  marginBottom: theme.spacing(3),
  "& .headerHold": {
    flexGrow: 1,
    alignItems: "center",
    justifyContent: "space-between",
  },
  [theme.breakpoints.up("md")]: {
    "& .sidenav": {
      display: "none",
    },
  },
  [theme.breakpoints.down("md")]: {
    flexDirection: "column",
  },
})); // ==============================================================

// ==============================================================
const DashboardHeader = ({ title, buttonText, href, Icon }) => {
  const isTablet = useMediaQuery((theme) => theme.breakpoints.down(1025));
  const HEADER_LINK = (
    <Button
      href={href}
      color="primary"
      LinkComponent={Link}
      sx={{
        bgcolor: "primary.light",
        px: 4,
      }}
    >
      {buttonText}
    </Button>
  );
  return (
    <StyledBox>
      <FlexBox mt={2} className="headerHold">
        <FlexBox alignItems="center" gap={1.5}>
          {Icon && <Icon color="primary" />}

          <H2 my={0} ellipsis>
            {title}
          </H2>
        </FlexBox>

        <div className="sidenav">
          <SideNav position="left" handle={<Menu fontSize="small" />}>
            <Navigation />
          </SideNav>
        </div>

        {!isTablet && buttonText ? HEADER_LINK : null}
      </FlexBox>

      {isTablet && buttonText ? <Box mt={2}>{HEADER_LINK}</Box> : null}
    </StyledBox>
  );
};

export default DashboardHeader;
